import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { TipoComponenteModel } from './../../model/endereco/tipocomponente.mode';
import { environment } from 'environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class TipoComponenteService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  getPageTipoComponente(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/page-tipo-componentes?page=${page}&size=${size}`, this.httpOptions);
  }

  getTipoComponentes(): Observable<TipoComponenteModel[]> {
    return this.httpClient.get<TipoComponenteModel[]>(this.apiURL + "/list-tipo-componentes", this.httpOptions);
  }

  adicionarTipoComponente(tipoComponente: TipoComponenteModel): Observable<TipoComponenteModel> {
    return this.httpClient.post<TipoComponenteModel>(this.apiURL + "/adicionar-tipo-componente", tipoComponente, this.httpOptions);
  }

  editarTipoComponente(tipoComponente: TipoComponenteModel): Observable<TipoComponenteModel> {
    return this.httpClient.put<TipoComponenteModel>(this.apiURL + "/editar-tipo-componente", tipoComponente, this.httpOptions);
  }

  apagarTipoComponente(tipoComponenteId: Number) {
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.delete(this.apiURL + `/excluir-tipo-componente/${tipoComponenteId}`,  { headers, responseType: 'text'});
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/endereco/tipo-componente.service.ts